
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { Auxiliary } from '../../../models/backend-definitions.module';
import { SnackBarService } from '../../../../cw-utils/snackbar.service';

@Injectable()
export class AuxiliaryEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    auxiliary: Auxiliary;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getAuxiliary()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getAuxiliary(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('auxiliary/wAll/' + this.routeParams.id).subscribe((res: Auxiliary ) => {
                    this.auxiliary = res;
                    this.onDataChanged.next(this.auxiliary);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(auxiliary): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('auxiliary/', auxiliary).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(auxiliary): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('auxiliary/', auxiliary).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(auxiliary): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('auxiliary/' + auxiliary.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
